import { render } from "./BlockModules.vue?vue&type=template&id=af78e55e&scoped=true"
import script from "./BlockModules.vue?vue&type=script&lang=js"
export * from "./BlockModules.vue?vue&type=script&lang=js"

import "./BlockModules.vue?vue&type=style&index=0&id=af78e55e&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af78e55e"]])

export default __exports__